import React, { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Card, Col, Container, Row } from "reactstrap"
import Logo from "../../../assets/images/logo.svg"
import moment from "moment"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { fetchFinanceVoucherSingle } from "../../../services/finance/finance"
import NumberFormat from "../../../utils/numberFormat"

const InventoryVoucherEntryView = ({ fromDashboard, viewValue }) => {
  const { id } = useParams()

  const viewId = fromDashboard ? viewValue?.value?.id : id

  const locations = useLocation();
  const crumb = locations?.state?.name || ""
  const delivery = locations?.state?.nameofd || ""

  const [invoiceDetails, setInvoiceDetails] = useState()
  const [tabledata, setTabledata] = useState()

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")
  useEffect(() => {
    const fetchInvoiceData = async () => {
      const response = await fetchFinanceVoucherSingle(viewId)
      setInvoiceDetails(response?.data)
      setTabledata(response?.data?.purchase_order?.purchaseorder_lists)
    }
    if (viewId !== undefined) fetchInvoiceData()
  }, [])

  const result = tabledata?.reduce(
    (acc, item) => {
      const received = item.received_quantity || 0
      return {
        totalreceived: Number(acc.totalreceived) + Number(received),
      }
    },
    { totalreceived: 0 }
  )

  const [discount, setDiscount] = useState()

  const handilCalaculation = data => {
    const total = data
      ?.map(item => Number(item?.credit_amount || 0))
      .reduce((sum, amount) => sum + amount, 0)
    console.log("handleCalculation", total)
    return total
  }

  const handilCalaculation2 = data => {
    const total = data
      ?.map(item => Number(item?.grn_quantity || 0))
      .reduce((sum, amount) => sum + amount, 0)
    console.log("handleCalculation", total)
    return total
  }

  const handilCalaculationvat = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 17
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 17)
          ?.debit_amount || 0
      : 0
    return otherCharge
  }

  const handilCalaculation3 = data => {
    // const qty = data
    //   ?.map(item => Number(item?.voucher_quantity || 0))
    //   .reduce((sum, amount) => sum + amount, 0)
    const total = data
      ?.map(
        item =>
          Number(item?.unit_price || 0) * Number(item?.voucher_quantity || 0)
      )
      .reduce((sum, amount) => sum + amount, 0)
    const totalvalue = total
    return totalvalue
  }

  const handilCalaculation4 = data => {
    const total = data
      ?.map(
        item => Number(item?.unit_price || 0) * Number(item?.po_quantity || 0)
      )
      .reduce((sum, amount) => sum + amount, 0)
    const totalvalue = total
    console.log("handleCalculation", totalvalue)
    return totalvalue
  }

  const handilDiscound15 = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 25
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 25)
          ?.credit_amount || 0
      : 0
    return otherCharge
  }

  const handilCalaculation5 = data => {
    const qty = data
      ?.map(item => Number(item?.quantity || 0))
      .reduce((sum, amount) => sum + amount, 0)
    const total = data
      ?.map(item => Number(item?.rate || 0))
      .reduce((sum, amount) => sum + amount, 0)
    const totalvalue = qty * total
    console.log("handleCalculation", totalvalue)
    return totalvalue
  }
  const handilCalaculationSale = data => {
    return data?.reduce((sum, item) => {
      const price = parseFloat(item?.unit_price || 0)
      const qty = parseFloat(item?.so_quantity || 0)
      return sum + price * qty
    }, 0)
  }

  const handilShipingCharg = data => {
    const journalEntryDetails = data?.some(detail => detail?.account_id == 3)
    const shippingCharge = journalEntryDetails
      ? data.find(detail => detail?.account_id == 3)?.debit_amount || 0
      : 0
    return shippingCharge
  }

  const handilOtherCharge = data => {
    const journalEntryDetails = data?.some(detail => detail?.account_id == 4)
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.account_id == 4)?.debit_amount || 0
      : 0
    return otherCharge
  }

  const handilRetention = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 4
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 2)
          ?.debit_amount || 0
      : 0
    console.log("handilRetention", journalEntryDetails, otherCharge)
    return otherCharge
  }
  const handilAdvRetention = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 2
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 2)
          ?.debit_amount || 0
      : 0
    console.log("handilRetention", journalEntryDetails, otherCharge)
    return otherCharge
  }

  // const handilVatchange = data => {
  //   const journalEntryDetails = data?.some(
  //     detail => detail?.ledger?.account_group_id == 17
  //   )
  //   const otherCharge = journalEntryDetails
  //     ? data.find(detail => detail?.ledger?.account_group_id == 17)
  //         ?.credit_amount || 0
  //     : 0
  //   return otherCharge
  // }

  const handilVatchange = data => {
    if (!Array.isArray(data)) return 0

    const match = data.find(detail => detail?.ledger?.account_group_id == 17)

    return match?.credit_amount || match?.debit_amount || 0
  }

  const handilDiscound = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 25
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 25)
          ?.credit_amount || 0
      : 0
    return otherCharge
  }

  const handleContaAmounts = journalEntryDetails =>
    journalEntryDetails?.reduce(
      (sum, entry) => sum + (parseFloat(entry?.credit_amount) || 0),
      0
    )

  const getLastAmount = journalEntryDetails => {
    const lastEntry = journalEntryDetails[journalEntryDetails?.length - 1]
    return lastEntry?.credit_amount !== null
      ? parseFloat(lastEntry?.credit_amount)
      : parseFloat(lastEntry?.debit_amount) || 0
  }

  const { totalreceived } = result || {}

  // Sub Total
  const subTotal16 =
    invoiceDetails?.purchaseorder?.materials?.reduce(
      (sum, item) =>
        sum + Number(item?.po_quantity || 0) * Number(item?.unit_price || 0),
      0
    ) || 0

  // Discount
  const discount16 =
    (subTotal16 * Number(invoiceDetails?.discount || 0)) / 100 || 0

  // VAT
  const vat16 =
    ((subTotal16 - discount16) * Number(invoiceDetails?.vat || 0)) / 100 || 0

  // Shipping Charge
  const shipping16 = Number(invoiceDetails?.purchaseorder?.shipping_charge || 0)

  // Other Charges
  const other16 = Number(invoiceDetails?.purchaseorder?.other_charge || 0)

  // Net Total
  const netTotal16 = subTotal16 - discount16 + vat16 + shipping16 + other16
  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            {!fromDashboard && (
              <Breadcrumbs
                title="Inventory"
                breadcrumbObject={[
                  { title: "Inventory", link: "/inventory" },
                  { title: crumb ? crumb : delivery ? delivery : "Inventory Voucher", link: "/inventory" },
                  // {
                  //   title: "Inventory Voucher Entry",
                  //   link: "/inventory-voucher",
                  // },
                  ...(crumb ? [{ title: "Goods Receipt Note", link: "/inventory-receipt-note" }] : delivery ? [{ title: "Delivery Note", link: "/inventory-delivery-note" }] : [{ title: "Inventory Voucher Entries", link: "/inventory-voucher" }]),
                  {
                    title: invoiceDetails?.voucher_type?.voucher_type
                      ? `${invoiceDetails?.voucher_type?.voucher_type} Voucher View`
                      : "Voucher View",
                    link: `/inventory-voucher/view/${viewId}`,
                  },
                ]}
              />
            )}
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div className="p-3">
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between me-2">
                      <h4 className="main-heading edittheamtitle">
                        {invoiceDetails?.voucher_type?.voucher_type
                          ? `${invoiceDetails?.voucher_type?.voucher_type} Voucher`
                          : "Voucher View"}
                      </h4>
                      <img className="view-logo" src={Logo} alt="logo" />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={11}>
                    <Row>
                      {invoiceDetails?.voucher_invoice === "Sales Account" ? (
                        <>
                          {invoiceDetails?.debit?.name && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">Party Name</div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.debit?.name}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.ref_number && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                Voucher Number
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.ref_number}
                              </div>
                            </Col>
                          )}
                        </>
                      ) : (
                        <>
                          {invoiceDetails?.voucher_type?.voucher_type && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                Voucher Type
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails
                                  ? invoiceDetails?.voucher_type?.voucher_type
                                  : "-"}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.ref_number && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                Voucher Number
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.ref_number}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.credit?.name && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">Party Name</div>
                              <div className="supplier-td-body">
                                {/* {invoiceDetails
                              ? invoiceDetails?.credit?.name
                              : "-"} */}

                                {invoiceDetails?.voucher_type?.voucher_type ==
                                "Sales"
                                  ? invoiceDetails?.debit?.name
                                  : invoiceDetails?.credit?.name}
                              </div>
                            </Col>
                          )}
                          {invoiceDetails?.debit?.name && (
                            <Col lg={2} md={4} sm={6}>
                              <div className="supplier-td-head">
                                {invoiceDetails?.voucher_type?.voucher_type ==
                                "Sales"
                                  ? "Sale Account"
                                  : invoiceDetails?.voucher_id == 7 ? "Default Location" : "Purchase Ledger"}
                              </div>
                              <div className="supplier-td-body">
                                {invoiceDetails?.voucher_type?.voucher_type ==
                                "Sales"
                                  ? invoiceDetails?.credit?.name
                                  : invoiceDetails?.debit?.name}
                              </div>
                            </Col>
                          )}
                        </>
                      )}
                      {invoiceDetails?.parent_voucher?.id && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">
                            Original INV No.
                          </div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.parent_voucher?.ref_number
                              ? invoiceDetails?.parent_voucher?.ref_number
                              : "-"}
                          </div>
                        </Col>
                      )}
                      {invoiceDetails?.inv_date && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Date</div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.inv_date
                              ? moment(invoiceDetails?.inv_date).format(
                                  "DD-MM-YYYY"
                                )
                              : "-"}
                          </div>
                        </Col>
                      )}
                      {invoiceDetails?.date && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Date</div>
                          <div className="supplier-td-body">
                            {invoiceDetails
                              ? moment(invoiceDetails?.date).format(
                                  "DD-MM-YYYY"
                                )
                              : "-"}
                          </div>
                        </Col>
                      )}

                      {invoiceDetails?.voucher_id == 12 && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Project Code</div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.project?.project_code
                              ? invoiceDetails?.project?.project_code
                              : "-"}
                          </div>
                        </Col>
                      )}
                      {invoiceDetails?.voucher_id == 12 && (
                        <Col lg={2} md={4} sm={6}>
                          <div className="supplier-td-head">Transfer Type</div>
                          <div className="supplier-td-body">
                            {invoiceDetails?.store_history[0]?.activity
                              ? invoiceDetails?.store_history[0]?.activity ==
                                "remove"
                                ? "Inward"
                                : "Outward"
                              : "-"}
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg={12}>
                    <h5 className="productDetail edittheamtitle">
                      {invoiceDetails?.voucher_id == 1 ||
                      invoiceDetails?.voucher_id == 3 ||
                      invoiceDetails?.voucher_id == 6 ||
                      invoiceDetails?.voucher_id == 8
                        ? "Details"
                        : invoiceDetails?.voucher_id == 13
                        ? "Sales Detail"
                        : invoiceDetails?.voucher_id == 19
                        ? ""
                        : "Material Details"}
                    </h5>
                  </Col>
                  <Col lg={12}>
                    {invoiceDetails?.voucher_id == 1 ||
                    invoiceDetails?.voucher_id == 3 ||
                    invoiceDetails?.voucher_id == 6 ||
                    invoiceDetails?.voucher_id == 8 ||
                    ([13, 18].includes(invoiceDetails?.voucher_id) &&
                      invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                    (invoiceDetails?.voucher_id == 15 &&
                      invoiceDetails?.voucher_invoice == "Purchase Voucher") ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Account</th>
                            <th className="text-end pe-2">Debit (AED)</th>
                            <th className="text-end pe-5">Credit (AED)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.journal_entry?.journal_entry_details?.map(
                            (data, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td className="ps-1">
                                    {Number(data?.debit_amount) != 0
                                      ? "Dr"
                                      : "Cr"}
                                  </td>
                                  <td className="ps-1">
                                    {data?.ledger?.name || "-"}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {data?.debit_amount
                                      ? NumberFormat(
                                          Number(data?.debit_amount),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}
                                  </td>
                                  <td className="ps-1 text-end pe-5">
                                    {data?.credit_amount
                                      ? NumberFormat(
                                          Number(data?.credit_amount),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}
                                  </td>
                                </tr>
                                {data?.voucher_partial_payment?.length ? (
                                  <tr className="td-wt-no-border">
                                    <td colSpan="4" className="ps-1">
                                      Details
                                    </td>
                                  </tr>
                                ) : (
                                  <></>
                                )}
                                {data?.voucher_partial_payment?.map(
                                  (item, paymentIndex) => (
                                    <React.Fragment key={paymentIndex}>
                                      <tr className="td-wt-no-border">
                                        <td colSpan="4" className=" ps-1">
                                          {item?.ref_id == 1
                                            ? "Advance"
                                            : item?.ref_id == 2
                                            ? "Against"
                                            : "New"}{" "}
                                          {item?.code} {item?.amount}{" "}
                                          {item?.credit_debit == "debit"
                                            ? "Dr"
                                            : "Cr"}
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  )
                                )}
                              </React.Fragment>
                            )
                          )}
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 7 ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Product Code</th>
                            <th>Description</th>
                            <th>Unit</th>
                            <th className="text-end pe-2">Ordered Quantity</th>
                            <th className="text-end pe-2">Recieved Quantity</th>
                            <th>Location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.grns?.materials?.map(
                            (data, index) => {
                              return (
                                <tr key={index}>
                                  <td className="ps-1">{index + 1}</td>
                                  <td className="ps-1">
                                    {data?.product?.product_code}
                                  </td>
                                  <td className="ps-1">
                                    {data?.product?.description}{" "}
                                  </td>
                                  <td className="ps-1">
                                    {data?.product?.unit?.unit_code}{" "}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {NumberFormat(Number(data.po_quantity), desimalrange, desimalrange)}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {NumberFormat(Number(data.grn_quantity), desimalrange, desimalrange)}
                                  </td>
                                  <td className="ps-1">
                                    {data?.ledger?.name ? data?.ledger?.name : "-"}
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 19 ? (
                      <>
                        {invoiceDetails?.delivery_notes?.materials?.length ? (
                          <>
                            <h5 className="productDetail edittheamtitle">
                              Materials
                            </h5>
                            <table className="estimation-table mb-4">
                              <thead>
                                <tr>
                                  <th>S No</th>
                                  <th>Product Code</th>
                                  <th>Product Name</th>
                                  {/* <th>Unit</th> */}
                                  <th className="text-end pe-2">
                                    Total Quantity
                                  </th>
                                  <th className="text-end pe-5">Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                {invoiceDetails?.delivery_notes?.materials?.map(
                                  (data, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="ps-1">{index + 1}</td>
                                        <td className="ps-1">
                                          {data?.material?.product_code}
                                        </td>
                                        <td className="ps-1">
                                          {data?.material?.description}{" "}
                                        </td>
                                        {/* <td className="ps-1">
                                    {data?.product?.unit?.unit_code}{" "}
                                  </td> */}
                                        <td className="ps-1 text-end pe-2">
                                          {NumberFormat(
                                            Number(data.total_quantity)
                                          )}
                                        </td>
                                        <td className="ps-1 text-end pe-5">
                                          {NumberFormat(Number(data.quantity))}
                                        </td>
                                      </tr>
                                    )
                                  }
                                )}
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <></>
                        )}
                        {invoiceDetails?.delivery_notes?.subcontract?.length ? (
                          <>
                            <h5 className="productDetail edittheamtitle">
                              Sub Contract
                            </h5>
                            <table className="estimation-table mb-4">
                              <thead>
                                <tr>
                                  <th>S No</th>
                                  <th>Code</th>
                                  <th>Name</th>
                                  {/* <th>Unit</th> */}
                                  <th className="text-end pe-2">
                                    Ordered Quantity
                                  </th>
                                  <th className="text-end pe-5">
                                    Recieved Quantity
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {invoiceDetails?.delivery_notes?.subcontract?.map(
                                  (data, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="ps-1">{index + 1}</td>
                                        <td className="ps-1">
                                          {data?.suppliers?.suppliers_code}
                                        </td>
                                        <td className="ps-1">
                                          {data?.suppliers?.name}{" "}
                                        </td>
                                        {/* <td className="ps-1">
                                    {data?.product?.unit?.unit_code}{" "}
                                  </td> */}
                                        <td className="ps-1 text-end pe-2">
                                          {NumberFormat(
                                            Number(data.total_quantity)
                                          )}
                                        </td>
                                        <td className="ps-1 text-end pe-5">
                                          {NumberFormat(Number(data.quantity))}
                                        </td>
                                      </tr>
                                    )
                                  }
                                )}
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : [17, 5].includes(invoiceDetails?.voucher_id) ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Product Code</th>
                            <th>Product Name</th>
                            <th className="text-end pe-2">Quantity</th>
                            <th className="text-end pe-2">Rate</th>
                            <th className="text-end pe-5">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(invoiceDetails?.voucher_id == 17
                            ? invoiceDetails?.rejection_in?.materials
                            : invoiceDetails?.rejection_out?.materials
                          )?.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td className="ps-1">{index + 1}</td>
                                <td className="ps-1">
                                  {data?.material?.product_code}
                                </td>
                                <td className="ps-1">
                                  {data?.material?.description}{" "}
                                </td>
                                {/* <td className="ps-1">
                                    {data?.product?.unit?.unit_code}{" "}
                                  </td> */}
                                
                                <td className="ps-1 text-end pe-2">
                                  {NumberFormat(Number(data.quantity), desimalrange, desimalrange)}
                                </td>
                                <td className="ps-1 text-end pe-2">
                                  {NumberFormat(Number(data.rate), desimalrange, desimalrange)}
                                </td>
                                <td className="ps-1 text-end pe-5">
                                  {NumberFormat(Number(data.quantity) * Number(data.rate), desimalrange, desimalrange)}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 15 &&
                      invoiceDetails?.voucher_invoice !== "Purchase Account" ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Product Code</th>
                            <th>Description</th>
                            <th>Unit</th>
                            <th className="text-end pe-2">Quantity</th>
                            <th className="text-end pe-2">Unit Price (AED)</th>
                            <th className="text-end pe-5">Sub Total (AED)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.purchasevoucher?.materials?.map(
                            (data, index) => {
                              return (
                                <tr key={index}>
                                  <td className="ps-1">{index + 1}</td>
                                  <td className="ps-1">
                                    {data?.product?.product_code}
                                  </td>
                                  <td className="ps-1">
                                    {data?.product?.description}{" "}
                                  </td>
                                  <td className="ps-1">
                                    {data?.product?.unit?.unit_code}{" "}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {NumberFormat(
                                      Number(data.voucher_quantity)
                                    )}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {NumberFormat(
                                      Number(data.unit_price),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </td>
                                  <td className="ps-1 text-end pe-5">
                                    {NumberFormat(
                                      Number(data.voucher_quantity) *
                                        Number(data.unit_price),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 15 &&
                      invoiceDetails?.voucher_invoice == "Purchase Account" ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Account Head</th>
                            <th className="text-end pe-5">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.journal_entry?.journal_entry_details
                            ?.slice(0, -1)
                            .map((item, idx) => (
                              <tr key={item.id}>
                                <td className="ps-2">{idx + 1}</td>
                                <td>{item?.ledger?.name || "-"}</td>
                                <td className="text-end pe-5">
                                  {item?.credit_amount
                                    ? NumberFormat(
                                        -Math.abs(item?.credit_amount)
                                      )
                                    : item?.debit_amount
                                    ? NumberFormat(item?.debit_amount)
                                    : NumberFormat(0.0)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 16 ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Product Code</th>
                            <th>Description</th>
                            <th>Unit</th>
                            <th className="text-end pe-2">Quantity</th>
                            <th className="text-end pe-2">Unit Price (AED)</th>
                            <th className="text-end pe-5">Sub Total (AED)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.purchaseorder?.materials?.map(
                            (data, index) => {
                              return (
                                <tr key={index}>
                                  <td className="ps-1">{index + 1}</td>
                                  <td className="ps-1">
                                    {data?.product?.product_code}
                                  </td>
                                  <td className="ps-1">
                                    {data?.product?.description}{" "}
                                  </td>
                                  <td className="ps-1">
                                    {data?.product?.unit?.unit_code}{" "}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {NumberFormat(Number(data.po_quantity))}
                                  </td>
                                  <td className="ps-1 text-end pe-2">
                                    {NumberFormat(
                                      Number(data.unit_price),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </td>
                                  <td className="ps-1 text-end pe-5">
                                    {NumberFormat(
                                      Number(data.po_quantity) *
                                        Number(data.unit_price),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </table>
                    ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                      invoiceDetails?.voucher_invoice ==
                        "Sales Product Invoice" ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Product Code</th>
                            <th>Description</th>
                            <th>Unit</th>
                            <th className="text-end pe-2">Quantity</th>
                            <th className="text-end pe-2">Unit Price (AED)</th>
                            <th className="text-end pe-5">Sub Total (AED)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {([13, 18].includes(invoiceDetails?.voucher_id)
                            ? invoiceDetails?.salesvoucher
                            : invoiceDetails?.purchasevoucher
                          )?.materials?.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td className="ps-1">{index + 1}</td>
                                <td className="ps-1">
                                  {data?.product?.product_code}
                                </td>
                                <td className="ps-1">
                                  {data?.product?.description}{" "}
                                </td>
                                <td className="ps-1">
                                  {data?.product?.unit?.unit_code}{" "}
                                </td>
                                <td className="ps-1 text-end pe-2">
                                  {NumberFormat(
                                    Number(
                                      [13, 18].includes(
                                        invoiceDetails?.voucher_id
                                      )
                                        ? data?.so_quantity
                                        : data?.po_quantity
                                    )
                                  )}
                                </td>
                                <td className="ps-1 text-end pe-2">
                                  {NumberFormat(
                                    Number(data.unit_price),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </td>
                                <td className="ps-1 text-end pe-5">
                                  {NumberFormat(
                                    Number(
                                      [13, 18].includes(
                                        invoiceDetails?.voucher_id
                                      )
                                        ? data?.so_quantity
                                        : data?.po_quantity
                                    ) * Number(data.unit_price),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                      invoiceDetails?.voucher_invoice == "Sales Invoice" ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Si No</th>
                            <th>Project</th>
                            <th>Reference</th>
                            <th>Unit</th>
                            <th className="text-end pe-5">Quantity</th>
                            <th className="text-end pe-5">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="ps-2">1</td>
                            <td>{invoiceDetails?.project?.project_code}</td>
                            <td>
                              {invoiceDetails?.manufacturing_journal?.code}
                            </td>
                            <td>Lsm</td>
                            <td className="text-end pe-5">1</td>
                            <td className="text-end pe-5">
                              {NumberFormat(
                                invoiceDetails?.sale_total,
                                desimalrange,
                                desimalrange
                              )}
                              {/* {NumberFormat(
                                Number(invoiceDetails?.sub_total) +
                                  Number(
                                    handilRetention(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ) +
                                  Number(
                                    handilDiscound(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ) -
                                  Number(
                                    handilVatchange(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                desimalrange,
                                desimalrange
                              )} */}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 13 &&
                      invoiceDetails?.voucher_invoice == "Sales Account" ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Si No</th>
                            <th>Account Head</th>
                            <th className="text-end pe-5">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.journal_entry?.journal_entry_details
                            ?.slice(0, -1)
                            .map((item, idx) => (
                              <tr key={item.id}>
                                <td className="ps-2">{idx + 1}</td>
                                <td>{item?.ledger?.name || "-"}</td>
                                <td className="text-end pe-5">
                                  {item?.credit_amount
                                    ? NumberFormat(
                                        item?.credit_amount,
                                        desimalrange,
                                        desimalrange
                                      )
                                    : item?.debit_amount
                                    ? NumberFormat(
                                        -Math.abs(item?.debit_amount),
                                        desimalrange,
                                        desimalrange
                                      )
                                    : NumberFormat(0.0)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    ) : invoiceDetails?.voucher_id == 12 ? (
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Si No</th>
                            <th>Product Code</th>
                            <th className="text-end pe-2">Quantity</th>
                            <th className="text-end pe-2">Rate</th>
                            <th className="text-end pe-5">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceDetails?.storeHistory?.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  {data?.product_id?.product_code
                                    ? data?.product_id?.product_code
                                    : "-"}
                                </td>
                                <td className="text-end pe-2">
                                  {data?.quantity
                                    ? NumberFormat(data?.quantity)
                                    : 0}
                                </td>
                                <td className="text-end pe-2">
                                  {data?.rate
                                    ? NumberFormat(
                                        data?.rate,
                                        desimalrange,
                                        desimalrange
                                      )
                                    : 0}
                                </td>
                                <td className="text-end pe-5">
                                  {NumberFormat(
                                    Number(data?.quantity || 0) *
                                      Number(data?.rate || 0),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <></>
                    )}
                  </Col>
                  {
                    // (invoiceDetails?.voucher_id == 13 &&
                    //   invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                    // (invoiceDetails?.voucher_id == 15 &&
                    //   invoiceDetails?.voucher_invoice == "Purchase Voucher") ||
                    [7, 19, 5, 17].includes(invoiceDetails?.voucher_id) ||
                    (invoiceDetails?.voucher_id == 15 &&
                      Number(
                        handilCalaculation3(
                          invoiceDetails?.purchasevoucher?.materials
                        )
                      ) == 0) ||
                    (invoiceDetails?.voucher_id == 16 &&
                      Number(
                        handilCalaculation4(
                          invoiceDetails?.purchaseorder?.materials
                        )
                      ) == 0) ||
                    (invoiceDetails?.voucher_id == 13 &&
                      Number(invoiceDetails?.sub_total) == 0 &&
                      invoiceDetails?.voucher_invoice != "Sales Account") ||
                    (invoiceDetails?.voucher_id == 12 &&
                      Number(
                        handilCalaculation5(invoiceDetails?.storeHistory)
                      ) == 0) ? (
                      <></>
                    ) : (
                      <Row>
                        <Col></Col>
                        <Col>
                          <Row>
                            <Col lg="6"></Col>
                            <Col lg="3" className="py-2">
                              <div className="text-end">
                                {invoiceDetails == null
                                  ? //  ||
                                    // invoiceDetails?.voucher_invoice ===
                                    //   "Purchase Account"
                                    ""
                                  : "Sub Total"}
                              </div>
                            </Col>
                            <Col lg="3" className="py-2">
                              {invoiceDetails?.voucher_id == 7 ? (
                                <div className="text-end pr-28-values">
                                  {NumberFormat(
                                    Number(
                                      handilCalaculation2(
                                        invoiceDetails?.recipt_note?.materials
                                      )
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              ) : invoiceDetails?.voucher_id == 15 &&
                                invoiceDetails?.voucher_invoice ==
                                  "Purchase Invoice" ? (
                                <div className="text-end pr-28-values">
                                  {NumberFormat(
                                    Number(
                                      handilCalaculation3(
                                        invoiceDetails?.purchasevoucher
                                          ?.materials
                                      )
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              ) : invoiceDetails?.voucher_id == 16 ? (
                                <div className="text-end pr-28-values">
                                  {NumberFormat(
                                    Number(
                                      handilCalaculation4(
                                        invoiceDetails?.purchaseorder?.materials
                                      )
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              ) : [13, 18].includes(
                                  invoiceDetails?.voucher_id
                                ) &&
                                invoiceDetails?.voucher_invoice ==
                                  "Sales Invoice" ? (
                                <div className="text-end pr-28-values">
                                  {NumberFormat(
                                    invoiceDetails?.sale_total,
                                    desimalrange,
                                    desimalrange
                                  )}
                                  {/* {NumberFormat(
                                  Number(invoiceDetails?.sub_total) +
                                    Number(
                                      handilRetention(
                                        invoiceDetails?.journal_entry
                                          ?.journal_entry_details
                                      )
                                    ) +
                                    Number(
                                      handilDiscound(
                                        invoiceDetails?.journal_entry
                                          ?.journal_entry_details
                                      )
                                    ) -
                                    Number(
                                      handilVatchange(
                                        invoiceDetails?.journal_entry
                                          ?.journal_entry_details
                                      )
                                    ),
                                  desimalrange,
                                  desimalrange
                                )} */}
                                </div>
                              ) : invoiceDetails?.voucher_id == 12 ? (
                                <div className="text-end pr-28-values">
                                  {NumberFormat(
                                    Number(
                                      handilCalaculation5(
                                        invoiceDetails?.storeHistory
                                      )
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              ) : [13, 18].includes(
                                  invoiceDetails?.voucher_id
                                ) &&
                                invoiceDetails?.voucher_invoice ==
                                  "Sales Product Invoice" ? (
                                <div className="text-end pr-28-values">
                                  {invoiceDetails?.voucher_id == 18
                                    ? NumberFormat(
                                        Number(invoiceDetails?.sub_total),
                                        desimalrange,
                                        desimalrange
                                      )
                                    : NumberFormat(
                                        Number(
                                          handilCalaculationSale(
                                            invoiceDetails?.salesvoucher
                                              ?.materials
                                          )
                                        ),
                                        desimalrange,
                                        desimalrange
                                      )}
                                </div>
                              ) : invoiceDetails?.voucher_id == 1 ||
                                invoiceDetails?.voucher_id == 3 ||
                                invoiceDetails?.voucher_id == 6 ||
                                invoiceDetails?.voucher_id == 8 ||
                                ([13, 18].includes(
                                  invoiceDetails?.voucher_id
                                ) &&
                                  ["Sales Account", "Sales Voucher"].includes(
                                    invoiceDetails?.voucher_invoice
                                  )) ||
                                ([15, 4].includes(invoiceDetails?.voucher_id) &&
                                  [
                                    "Purchase Account",
                                    "Purchase Voucher",
                                  ].includes(
                                    invoiceDetails?.voucher_invoice
                                  )) ? (
                                <div className="text-end pr-28-values">
                                  {[
                                    "Sales Account",
                                    "Purchase Account",
                                  ].includes(invoiceDetails?.voucher_invoice)
                                    ? NumberFormat(
                                        Number(
                                          getLastAmount(
                                            invoiceDetails?.journal_entry
                                              ?.journal_entry_details || []
                                          )
                                        ),
                                        desimalrange,
                                        desimalrange
                                      )
                                    : NumberFormat(
                                        Number(
                                          handleContaAmounts(
                                            invoiceDetails?.journal_entry
                                              ?.journal_entry_details || []
                                          )
                                        ),
                                        desimalrange,
                                        desimalrange
                                      )}
                                </div>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )
                  }
                  {invoiceDetails?.voucher_id == 13 &&
                  invoiceDetails?.voucher_invoice == "Sales Invoice" &&
                  handilRetention(
                    invoiceDetails?.journal_entry?.journal_entry_details
                  ) > 0 ? (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null ? "" : "Retention"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {invoiceDetails?.voucher_id == 13 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  handilRetention(
                                    invoiceDetails?.journal_entry
                                      ?.journal_entry_details
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {invoiceDetails?.voucher_id == 13 &&
                  invoiceDetails?.voucher_invoice == "Sales Invoice" &&
                  handilAdvRetention(
                    invoiceDetails?.journal_entry?.journal_entry_details
                  ) > 0 ? (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null
                                ? ""
                                : "Advance Retention"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {invoiceDetails?.voucher_id == 13 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  handilAdvRetention(
                                    invoiceDetails?.journal_entry
                                      ?.journal_entry_details
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {invoiceDetails?.voucher_id == 1 ||
                  invoiceDetails?.voucher_id == 3 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 8 ||
                  invoiceDetails?.voucher_id == 19 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 5 ||
                  invoiceDetails?.voucher_id == 17 ||
                  ([13, 18].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                  (invoiceDetails?.voucher_id == 18 &&
                    invoiceDetails?.voucher_invoice ==
                      "Sales Product Invoice") ||
                  (invoiceDetails?.voucher_id == 18 &&
                    invoiceDetails?.voucher_invoice == "Sales Invoice") ||
                  (invoiceDetails?.voucher_id == 15 &&
                    invoiceDetails?.voucher_invoice == "Purchase Voucher") ||
                  (invoiceDetails?.voucher_id == 7 &&
                    Number(
                      (handilCalaculation2(
                        invoiceDetails?.recipt_note?.materials
                      ) *
                        Number(invoiceDetails?.discount)) /
                        100
                    ) != 0) ||
                  (invoiceDetails?.voucher_id == 15 &&
                    Number(
                      handilDiscound15(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 16 &&
                    Number(
                      (handilCalaculation4(
                        invoiceDetails?.purchaseorder?.materials
                      ) *
                        Number(invoiceDetails?.discount)) /
                        100
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 13 &&
                    handilDiscound(
                      invoiceDetails?.journal_entry?.journal_entry_details
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 12 &&
                    Number(
                      (handilCalaculation5(invoiceDetails?.storeHistory) *
                        Number(invoiceDetails?.discount)) /
                        100
                    ) == 0) ? (
                    <></>
                  ) : (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null ||
                              invoiceDetails?.voucher_invoice ===
                                "Sales Account"
                                ? ""
                                : "Discount"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {invoiceDetails?.voucher_id == 7 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    (handilCalaculation2(
                                      invoiceDetails?.recipt_note?.materials
                                    ) *
                                      Number(invoiceDetails?.discount)) /
                                      100
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 15 &&
                              invoiceDetails?.voucher_invoice ==
                                "Purchase Invoice" ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilDiscound15(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 16 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    (handilCalaculation4(
                                      invoiceDetails?.purchaseorder?.materials
                                    ) *
                                      Number(invoiceDetails?.discount)) /
                                      100
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 13 &&
                              invoiceDetails?.voucher_invoice ==
                                "Sales Invoice" ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  handilDiscound(
                                    invoiceDetails?.journal_entry
                                      ?.journal_entry_details
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 12 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    (handilCalaculation5(
                                      invoiceDetails?.storeHistory
                                    ) *
                                      Number(invoiceDetails?.discount)) /
                                      100
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {invoiceDetails?.voucher_id == 1 ||
                  invoiceDetails?.voucher_id == 3 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 8 ||
                  invoiceDetails?.voucher_id == 19 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 5 ||
                  invoiceDetails?.voucher_id == 17 ||
                  ([13, 18].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                  (invoiceDetails?.voucher_id == 18 &&
                    invoiceDetails?.voucher_invoice == "Sales Invoice") ||
                  (invoiceDetails?.voucher_id == 15 &&
                    invoiceDetails?.voucher_invoice == "Purchase Voucher") ||
                  (invoiceDetails?.voucher_id == 18 &&
                    invoiceDetails?.voucher_invoice ==
                      "Sales Product Invoice") ||
                  (invoiceDetails?.voucher_id == 7 &&
                    Number(
                      handilShipingCharg(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 15 &&
                    Number(
                      handilShipingCharg(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 16 &&
                    Number(invoiceDetails?.purchaseorder?.shipping_charge) ==
                      0) ||
                  invoiceDetails?.voucher_id == 13 ||
                  (invoiceDetails?.voucher_id == 12 &&
                    Number(
                      handilShipingCharg(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ? (
                    <></>
                  ) : (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null ? "" : "Shipping Charge"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {invoiceDetails?.voucher_id == 7 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilShipingCharg(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 15 &&
                              invoiceDetails?.voucher_invoice ==
                                "Purchase Invoice" ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilShipingCharg(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 16 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    invoiceDetails?.purchaseorder
                                      ?.shipping_charge
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 12 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilShipingCharg(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {invoiceDetails?.voucher_id == 1 ||
                  invoiceDetails?.voucher_id == 3 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 8 ||
                  invoiceDetails?.voucher_id == 19 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 5 ||
                  invoiceDetails?.voucher_id == 17 ||
                  ([13, 18].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                  ([4, 15].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Purchase Voucher") ||
                  (invoiceDetails?.voucher_id == 18 &&
                    invoiceDetails?.voucher_invoice == "Sales Invoice") ||
                  (invoiceDetails?.voucher_id == 18 &&
                    invoiceDetails?.voucher_invoice ==
                      "Sales Product Invoice") ||
                  (invoiceDetails?.voucher_id == 7 &&
                    Number(
                      handilOtherCharge(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 15 &&
                    Number(
                      handilOtherCharge(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 16 &&
                    Number(invoiceDetails?.purchaseorder?.other_charge) == 0) ||
                  invoiceDetails?.voucher_id == 13 ||
                  (invoiceDetails?.voucher_id == 12 &&
                    Number(
                      handilOtherCharge(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ? (
                    <></>
                  ) : (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null ? "" : "Other Charges"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {invoiceDetails?.voucher_id == 7 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilOtherCharge(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 15 &&
                              invoiceDetails?.voucher_invoice ==
                                "Purchase Invoice" ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilOtherCharge(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 16 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    invoiceDetails?.purchaseorder?.other_charge
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 12 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilOtherCharge(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {/* {invoiceDetails?.voucher_id == 13 &&
                  invoiceDetails?.voucher_invoice == "Sales Product Invoice" &&
                  Number(
                    handilCalaculationSale(
                      invoiceDetails?.salesvoucher?.materials
                    )
                  ) != Number(invoiceDetails?.sub_total) ? (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">VAT</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end pr-28-values">
                              {(
                                Number(invoiceDetails?.sub_total) -
                                Number(
                                  handilCalaculationSale(
                                    invoiceDetails?.salesvoucher?.materials
                                  )
                                )
                              ).toFixed(desimalrange)}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )} */}

                  {invoiceDetails?.voucher_id == 1 ||
                  invoiceDetails?.voucher_id == 3 ||
                  invoiceDetails?.voucher_id == 6 ||
                  invoiceDetails?.voucher_id == 8 ||
                  (invoiceDetails?.voucher_id == 13 &&
                    invoiceDetails?.voucher_invoice == "Sales Voucher") ||
                  (invoiceDetails?.voucher_id == 15 &&
                    invoiceDetails?.voucher_invoice == "Purchase Voucher") ||
                  (invoiceDetails?.voucher_id == 7 &&
                    Number(
                      (handilCalaculation2(
                        invoiceDetails?.recipt_note?.materials
                      ) *
                        Number(invoiceDetails?.vat)) /
                        100
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 15 &&
                    Number(
                      handilCalaculationvat(
                        invoiceDetails?.journal_entry?.journal_entry_details
                      )
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 16 &&
                    Number(
                      (handilCalaculation4(
                        invoiceDetails?.purchaseorder?.materials
                      ) *
                        Number(invoiceDetails?.vat)) /
                        100
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 13 &&
                    handilVatchange(
                      invoiceDetails?.journal_entry?.journal_entry_details
                    ) == 0) ||
                  (invoiceDetails?.voucher_id == 12 &&
                    Number(
                      (handilCalaculation5(invoiceDetails?.storeHistory) *
                        Number(invoiceDetails?.vat)) /
                        100
                    ) == 0) ||
                  Number(
                    handilVatchange(
                      invoiceDetails?.journal_entry?.journal_entry_details
                    )
                  ) == 0 ? (
                    <></>
                  ) : (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {[
                                "Sales Invoice",
                                "Sales Product Invoice",
                                "Purchase Invoice",
                              ].includes(invoiceDetails?.voucher_invoice)
                                ? "VAT"
                                : ""}
                            </div>
                          </Col>

                          <Col lg="3" className="py-2">
                            {invoiceDetails?.voucher_id == 7 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    (handilCalaculation2(
                                      invoiceDetails?.recipt_note?.materials
                                    ) *
                                      Number(invoiceDetails?.vat)) /
                                      100
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 15 &&
                              invoiceDetails?.voucher_invoice ==
                                "Purchase Invoice" ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilCalaculationvat(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 16 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    (handilCalaculation4(
                                      invoiceDetails?.purchaseorder?.materials
                                    ) *
                                      Number(invoiceDetails?.vat)) /
                                      100
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : [13, 18].includes(invoiceDetails?.voucher_id) &&
                              [
                                "Sales Invoice",
                                "Sales Product Invoice",
                              ].includes(invoiceDetails?.voucher_invoice) ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  handilVatchange(
                                    invoiceDetails?.journal_entry
                                      ?.journal_entry_details
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 12 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    (handilCalaculation5(
                                      invoiceDetails?.storeHistory
                                    ) *
                                      Number(invoiceDetails?.vat)) /
                                      100
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {invoiceDetails?.voucher_id == 13 &&
                  invoiceDetails?.voucher_invoice == "Sales Product Invoice" &&
                  Number(
                    handilCalaculationSale(
                      invoiceDetails?.salesvoucher?.materials
                    )
                  ) != Number(invoiceDetails?.sub_total) ? (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Net Total</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end pr-28-values">
                              {Number(invoiceDetails?.sub_total).toFixed(
                                desimalrange
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}

                  {([13, 18].includes(invoiceDetails?.voucher_id) &&
                    invoiceDetails?.voucher_invoice == "Sales Invoice") ||
                  (invoiceDetails?.voucher_id == 15 &&
                    invoiceDetails?.voucher_invoice == "Purchase Invoice") ? (
                    <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null ? "" : "Net Total"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {[13, 18].includes(invoiceDetails?.voucher_id) ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(invoiceDetails?.sub_total),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : invoiceDetails?.voucher_id == 15 ? (
                              <div className="text-end pr-28-values">
                                {NumberFormat(
                                  Number(
                                    handilCalaculation3(
                                      invoiceDetails?.purchasevoucher?.materials
                                    ) +
                                      Number(
                                        handilShipingCharg(
                                          invoiceDetails?.journal_entry
                                            ?.journal_entry_details
                                        )
                                      ) +
                                      Number(
                                        handilOtherCharge(
                                          invoiceDetails?.journal_entry
                                            ?.journal_entry_details
                                        )
                                      ) +
                                      Number(
                                        handilCalaculationvat(
                                          invoiceDetails?.journal_entry
                                            ?.journal_entry_details
                                        )
                                      ) -
                                      Number(
                                        handilDiscound15(
                                          invoiceDetails?.journal_entry
                                            ?.journal_entry_details
                                        )
                                      )
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {/* {(invoiceDetails?.voucher_id == 13 &&
                              invoiceDetails?.voucher_invoice ==
                                "Sales Voucher") && 
                                <Row>
                      <Col></Col>
                      <Col>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">
                              {invoiceDetails == null ? "" : "Sub Total"}
                            </div>
                          </Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end pr-28-values">
                            {NumberFormat(
                                  Number(
                                    handilCalaculation(
                                      invoiceDetails?.journal_entry
                                        ?.journal_entry_details
                                    )
                                  ),
                                  3,
                                  3
                                )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                                } */}
                  {invoiceDetails?.voucher_id == 16 && (
                    <>
                      <Row>
                        <Col></Col>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col></Col>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col></Col>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col></Col>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col></Col>
                        <Col>
                          <Row>
                            <Col lg="6"></Col>
                            <Col lg="3" className="py-2">
                              <div className="text-end">Net Total</div>
                            </Col>
                            <Col lg="3" className="py-2">
                              <div className="text-end pr-28-values">
                                {NumberFormat(netTotal16, 3, 3)}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                </Row>
              </div>
            </Card>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default InventoryVoucherEntryView
